/**
 * Supabase Client Configuration
 *
 * REUSABLE: Copy this file to other Gatsby projects
 * Required env vars: GATSBY_SUPABASE_URL, GATSBY_SUPABASE_ANON_KEY
 */

import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.GATSBY_SUPABASE_URL
const supabaseAnonKey = process.env.GATSBY_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase environment variables are missing. Auth will not work.')
}

export const supabase = createClient(supabaseUrl || '', supabaseAnonKey || '', {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    // Bypass navigator.locks entirely. The password-update deadlock that previously
    // required this lock is now handled by calling the Supabase REST API directly,
    // so the lock is no longer needed and only causes AbortError timeouts in dev.
    lock: async (name, acquireTimeout, fn) => fn()
  }
})

export default supabase
